import { Pipe, PipeTransform } from '@angular/core';
import { Translatable } from '../translation/translatable';
import { TranslatePipe } from '../translation/translate.pipe';
import { DatePipe } from '@angular/common';
import { ResourceConfigDisplayDatas } from './resources-interfaces/resource-config';

@Pipe({
  name: 'displayData',
})
export class DisplayDataPipe implements PipeTransform {
  constructor(private translate: TranslatePipe, private date: DatePipe) {}

  transform(
    source: any,
    path: string | string[],
    config?: ResourceConfigDisplayDatas
  ): string {
    if (typeof source === 'object') {
      if (Array.isArray(path)) {
        return path.map((p) => this.display(source, p, config)).join(' - ');
      } else {
        return this.display(source, path, config);
      }
    }
    return source;
  }

  private display(
    source: any,
    path: string,
    config?: ResourceConfigDisplayDatas
  ): string {
    let unit = '';
    const display = this.value(source, path, config?.type === 'date');
    if (config?.addUnit) {
      unit = ` ${
        config?.addUnit.fix
          ? config?.addUnit.fix
          : this.value(source, config.addUnit.path!, false)
      }`;
    }
    return config?.nullIfEmpty && display === '-'
      ? ''
      : config?.zeroIsNull && display === '0'
      ? ''
      : display + unit;
  }

  private value(source: any, path: string, date: boolean | undefined) {
    let res = path.split('.').reduce((o, k) => o && o[k], source);
    res = res === 0 ? '0' : res;
    const translatable = typeof res === 'object';
    return res
      ? date
        ? this.date.transform(res, 'mediumDate')
        : translatable
        ? this.translate.transform(res)
        : res.toString()
      : '-';
  }
}
